import { ROUTE_HEALTH_DATA } from '@/constants/routes';
import setTitleFromLoader from '@/utils/routing/set-title';
import { RouteObject } from 'react-router-dom';
import Page from './health-data.page';

export const routeHealthData: RouteObject = {
  path: ROUTE_HEALTH_DATA,
  Component: Page,
  loader() {
    return setTitleFromLoader('Health Data')();
  },
};
